export class NICEMediaTypes
{
    MediaTypeId: number;
    MediaTypeName: string;

    constructor(mediaTypeResponse)
    {
        if (mediaTypeResponse != null) {
            this.MediaTypeId = mediaTypeResponse.MediaTypeId;
            this.MediaTypeName = mediaTypeResponse.MediaTypeName;
        }
    }
}
